import React, { Component } from "react";
import ReactGA from "react-ga";
import { NavLink } from "react-router-dom";

//Images
import logo from "assets/img/logo/app-icon-transparent.png";
import notificationStatus from 'assets/img/notificationStatus.png';
import AccountManagementWhite from 'assets/img/Account_Management_white.png';
import DashboardWhite from 'assets/img/Dashboard_white.png';
import LockListWhite from 'assets/img/LockList_white.png';
import NotificationsWhite from 'assets/img/Notifications_white.png';
import RetractAccessWhite from 'assets/img/Retract_Access.png';
import UserManagementWhite from 'assets/img/User_Management_white.png';
import MultiapprovalWhite from 'assets/img/Multiapproval_white.png';
import GranttAccessWhite from 'assets/img/Grant_Access_white.png';
import AuditTrailWhite from 'assets/img/Audit_Trail_white.png';
import StarterGuideWhite from 'assets/img/Starter_Guide3_White.png';
import PlanSubscriptionWhite from 'assets/img/Plan_Subscription_White.png';
import AccessTrackingWhite from 'assets/img/Access_Tracking_white.png';


import { HeaderLinks } from "../Header/Header";
import "routes/app.jsx";
import AuthUserContext from "../Auth/AuthUserContext";
import { customLog, deploymentEnvironment } from "../../variables/Variables";

import { fire, auth } from "../../firebase/index";

// routes
import "../../routes/app";

//HttpsRedirect
import HttpsRedirect from "react-https-redirect";

//Authentication
import withAuth from "../../components/Auth/withAuth";

import SuperAdminRoutes from "../../containers/App/SuperAdminRoutes";
import LoginAndSignUpRoute from "../../containers/App/LoginAndSignUpRoute";
import AdminRoutes from "../../containers/App/AdminRoutes";
import MemberRoutes from "../../containers/App/MemberRoutes";
import NewUserRoutes from "../../containers/App/NewUserRoutes";
import Loading from "../Loading/Loading";
//Css
import "../../assets/css/maincss.css";

import LocalizedStrings from "react-localization";
// import { isEmpty } from "lodash";
// import { props } from "bluebird";
// import { useContext } from "react";
// import { Sidebar } from "semantic-ui-react";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    dashboard: "Dashboard",
    locklist: "Locklist",
    userManagement: "User Management",
    recipientManagement: "Recipient Management",
    grantAccess: "Grant Access",
    retractAccess: "Retract Access",
    shareHistory: "Share History",
    auditTrail: "Audit Trail",
    auditTrailMapview: "Audit Trail Mapview",
    accountManagement: "Account Management",
    logIn: "Log In",
    signUp: "Sign Up",
    plansSubscription: "Plans Subscription",
    groupManagement: "Group Management",
    multiApprove: "Multi Approval",
    tutorial: "Starter Guide",
    overview: "Overview",
    memberManagement: "Member Management",
    subscriptionPackage: "New Subscription",
    contactUs: "Contact Us",
    setting: "Setting",
    logs: "Notifications / Activity",
    diginaswebsite: "Digipas Technologies Inc.",
    proversion: "Pro Version 6.15.02",
    Access_Tracking: "Access Tracking",
  },
  ja: {
    dashboard: "ダッシュボード",
    locklist: "ハードウェアリスト",
    userManagement: "メンバー管理",
    recipientManagement: "メンバー管理",
    grantAccess: "アクセス設定",
    retractAccess: "アクセス権限設定",
    shareHistory: "アクセス権限一覧",
    auditTrail: "アクセス履歴一覧",
    auditTrailMapview: "地図表示",
    accountManagement: "アカウント管理",
    logIn: "ログインする",
    signUp: "サインアップ",
    plansSubscription: "サブスクリプション管理",
    groupManagement: "グループ管理",
    multiApprove: "承認",
    tutorial: "チュートリアル",
    overview: "各操作手順",
    memberManagement: "メンバー管理",
    subscriptionPackage: "サブスクリプションパッケージ",
    contactUs: "お問い合わせ",
    setting: "設定",
    logs: "通知／履歴",
    diginaswebsite: "デジパステック株式会社",
    proversion: "プロバージョン 6.15.02",
    Access_Tracking: "アクセス追跡",
  },
  es: {
    dashboard: "Panel de Control",
    locklist: "Lista de Candados",
    userManagement: "Gestión de Usuarios",
    recipientManagement: "Gestión de Receptores",
    grantAccess: "Conceder Acceso",
    retractAccess: "Revocar Acceso",
    shareHistory: "Historial de Compartición",
    auditTrail: "Registro de Auditoría",
    auditTrailMapview: "Vista de Mapa del Registro de Auditoría",
    accountManagement: "Gestión de Cuentas",
    logIn: "Iniciar Sesión",
    signUp: "Registrarse",
    plansSubscription: "Suscripción de Planes",
    groupManagement: "Gestión de Grupos",
    multiApprove: "Aprobación Múltiple",
    tutorial: "Guía de Inicio",
    overview: "Visión General",
    memberManagement: "Gestión de Miembros",
    subscriptionPackage: "Nueva Suscripción",
    contactUs: "Contáctanos",
    setting: "Configuración",
    logs: "Notificaciones / Actividad",
    diginaswebsite: "Digipas Technologies Inc.",
    proversion: "Versión Pro 6.15.02",
    Access_Tracking: "Seguimiento de Acceso",
  },
});
//Inline css
//Sidebar icons style
// const iconStyle = {
//   fontSize: "25px",
//   marginRight: "20px"
// };

//NavStyle(flex it)
// const navLinkStyle = {
//   display: "flex"
// };

//Paragraph style (Gaps inbetween)
// const paraStyle = {
//   lineHeight: "5px",
//   width: "250px",
//   marginTop: "5px"
// };
var trackerID = "";
if (deploymentEnvironment) {
  //! Live
  trackerID = "G-7D4M74VB11";
} else {
  //! Test
  trackerID = "G-LWK1V2E1FE";
}
ReactGA.initialize(trackerID, {
  debug: !deploymentEnvironment
});

const Navigation = props => {
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, []);

  if (isLoading) {
    return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
  </div>
    ;
  }

  return (
    <AuthUserContext.Consumer>
      {authUser => {
        // customLog(authUser);

        if (authUser) {
          //check out "withAuth.jsx" !
          //Set everything there can alr !
          if (authUser.isPaymentValid) {
            if (authUser.isSuperAdmin) {
              return <NavigationSuperAdmin authUser={authUser} notifStatus={props.notifStatus} checkNotif={props.checkNotif} />;
            } else if (authUser.isAdmin) {
              return <NavigationAuthAdmin notifStatus={props.notifStatus} checkNotif={props.checkNotif} />;
            } else {
              return <NavigationAuthNonAdmin />;
            }
          } else {
            if (authUser.notPartOfMember) {
              return <NavigationNewMember />;
            } else {
              return <NavigationAuthNonAdmin />;
            }
          }
        } else if (authUser === null) {
          return <NavigationNonAuth />;
        } else {
          return;
        }
      }}
    </AuthUserContext.Consumer>
  );
};


const getAuthUser = (Sidebar) => {
  {/* TO SET LANGUAGE */ }
  return (
    <AuthUserContext.Consumer>
      {authUser => {
        if (authUser) {
          return (
            <Sidebar authUser={authUser} />
          )
        }
      }}
    </AuthUserContext.Consumer>
  )
}

const NavigationNewMember = () => {
  return (
    <div className="nav">
      <li>
        <NavLink to="/tutorial" className="nav-link">
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={StarterGuideWhite} alt="StarterGuideWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.tutorial}</p>
            </div>
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/plans"
          className="nav-link"
          onClick={() => {
            ReactGA.event(
              {
                category: "plan subscription",
                action: "enter plan subscription page",
                value: 1
              },
              [trackerID]
            );
          }}
        >
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={PlanSubscriptionWhite} alt="PlanSubscriptionWhite" />
            <p className="navItemStyle">
              {localizationStrings.plansSubscription}
            </p>
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/accountManagement"
          className="nav-link"
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-id" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={AccountManagementWhite} alt="AccountManagementWhite" />
            <div>
              <p className="navItemStyle">
                {localizationStrings.accountManagement}
              </p>
            </div>
          </div>
        </NavLink>
      </li>

      {/* <li>
        <NavLink to="/contactUs" className="nav-link">
          <div>
            <p className="navItemStyle">{localizationStrings.contactUs}</p>
          </div>
        </NavLink>
      </li> */}
    </div>
  );
};

const NavigationAuthNonAdmin = () => {
  return (
    <div className="nav">
      <li>
        <NavLink
          to="/accountManagement"
          className="nav-link"
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-id" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={AccountManagementWhite} alt="AccountManagementWhite" />
            <div>
              <p className="navItemStyle">
                {localizationStrings.accountManagement}
              </p>
            </div>
          </div>
        </NavLink>
      </li>

      {/* <li>
        <NavLink to="/setting" className="nav-link">
          <div>
            <p className="navItemStyle">{localizationStrings.setting}</p>
          </div>
        </NavLink>
      </li> */}

      {/* <li>
        <NavLink to="/contactUs" className="nav-link">
          <div>
            <p className="navItemStyle">{localizationStrings.contactUs}</p>
          </div>
        </NavLink>
      </li> */}
    </div>
  );
};

const NavigationAuthAdmin = props => {
  // customLog(isPaid);
  return (
    <div className="nav">
      <li>
        <NavLink
          to="/dashboard"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-global" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={DashboardWhite} alt="DashboardWhite" />
            <div>
              <p className ="navItemStyle" aria-current="page">{localizationStrings.dashboard}</p>
            </div>
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink to="/logs" className="nav-link" onClick={() => props.checkNotif()}>
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={NotificationsWhite} alt="NotificationsWhite" />
            <p className="navItemStyle">{localizationStrings.logs}</p>
            <div className="navItemStyle">
              {props.notifStatus === true ? <img style={{height: "10px", width: "10px", margin: "auto"}} src={notificationStatus} alt="notificationStatus" /> : ""}
            </div>
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/locklist"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-note2" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={LockListWhite} alt="LockListWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.locklist}</p>
            </div>
          </div>
        </NavLink>
      </li>
      {/* <li>
        <NavLink to="/memberManagement" className="nav-link">
          <div>
            <p className="navItemStyle">
              {localizationStrings.memberManagement}
            </p>
          </div>
        </NavLink>
      </li> */}
      {/* <li>
        <NavLink
          to="/recipientManagement"
          className="nav-link"
          // style={navLinkStyle}
        > */}
      {/* <i className="pe-7s-user" style={iconStyle} /> */}
      {/* <div>
            <p className="navItemStyle">
              {localizationStrings.recipientManagement}
            </p>
          </div>
        </NavLink>
      </li> */}

      <li>
        <NavLink to="/userManagement" className="nav-link" onClick={() => props.checkNotif()}>
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={UserManagementWhite} alt="UserManagementWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.userManagement}</p>
            </div>
          </div>
        </NavLink>
      </li>

      <li>
        <NavLink
          to="/grantAccess"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-unlock" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={GranttAccessWhite} alt="GranttAccessWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.grantAccess}</p>
            </div>
          </div>
        </NavLink>
      </li>
      {/* <li>
        <NavLink
          to="/groupManagement"
          className="nav-link"
        >
          <div>
            <p className="navItemStyle">
              {localizationStrings.groupManagement}
            </p>
          </div>
        </NavLink>
      </li> */}

      <li>
        <NavLink to="/multiApprove" className="nav-link" onClick={() => props.checkNotif()}>
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={MultiapprovalWhite} alt="MultiapprovalWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.multiApprove}</p>
            </div>
          </div>
        </NavLink>
      </li>

      <li>
        <NavLink
          to="/retractableAccess"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-shuffle" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={RetractAccessWhite} alt="RetractAccessWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.retractAccess}</p>
            </div>
          </div>
        </NavLink>
      </li>
      {/* <li>
        <NavLink
          to="/shareHistory"
          className="nav-link"
        >
          <div>
            <p className="navItemStyle">{localizationStrings.shareHistory}</p>
          </div>
        </NavLink>
      </li> */}
      <li>
        <NavLink
          to="/audittrail"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-map-2" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={AuditTrailWhite} alt="AuditTrailWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.auditTrail}</p>
            </div>
          </div>
        </NavLink>
      </li>

      <li>
        <NavLink
          to="/accountManagement"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-id" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={AccountManagementWhite} alt="AccountManagementWhite" />
            <div>
              <p className="navItemStyle">
                {localizationStrings.accountManagement}
              </p>
            </div>
          </div>
        </NavLink>
      </li>

      {/* <li>
        <NavLink to="/setting" className="nav-link" onClick={() => props.checkNotif()}>
          <div>
            <p className="navItemStyle">{localizationStrings.setting}</p>
          </div>
        </NavLink>
      </li> */}

      {/* <li>
        <NavLink to="/logs" className="nav-link">
          <div style={{display: "flex"}}>
            <p className="navItemStyle">{localizationStrings.logs}</p>
            <div className="navItemStyle">
              {props.notifStatus === true ? <img style={{height: "10px", width: "10px"}} src={notificationStatus} alt="notificationStatus" /> : ""}
            </div>
          </div>
        </NavLink>
      </li> */}

      {/* <li>
        <NavLink to="/contactUs" className="nav-link">
          <div>
            <p className="navItemStyle">{localizationStrings.contactUs}</p>
          </div>
        </NavLink>
      </li> */}

      {/* <li>
        <NavLink to="/inviteuser" className="nav-link" style={navLinkStyle}>
          <i className="pe-7s-add-user" style={iconStyle}></i>
          <div>
            <p>Invite Members</p>
            <p>アカウント管理</p>
          </div>
        </NavLink>
      </li> */}

      {/* <li>
        <NavLink to="/groupManagement" className="nav-link">
          <div>
            <p className="navItemStyle">Group Management</p>
          </div>
        </NavLink>
      </li> */}
    </div>
  );
};

const NavigationNonAuth = () => {
  return (
    <div className="nav">
      <li>
        <NavLink to="/login" className="nav-link">
          {/* <i className="pe-7s-next-2" /> */}
          <p className="navItemStyle">{localizationStrings.logIn}</p>
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/signup"
          className="nav-link"
          onClick={() => {
            ReactGA.event(
              {
                category: "register",
                action: "enter register page",
                value: 1
              },
              [trackerID]
            );
          }}
        >
          <p className="navItemStyle">{localizationStrings.signUp}</p>
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/package"
          className="nav-link"
          onClick={() => {
            ReactGA.event(
              {
                category: "subscription",
                action: "enter subscription package page",
                value: 1
              },
              [trackerID]
            );
          }}
        >
          <p className="navItemStyle">
            {localizationStrings.subscriptionPackage}
          </p>
        </NavLink>
      </li>
      {/* <li>
        <NavLink to="/contactUs" className="nav-link">
          <div>
            <p className="navItemStyle">{localizationStrings.contactUs}</p>
          </div>
        </NavLink>
      </li> */}
      {/* <li>
        <NavLink to="/#" className="nav-link">
          <i className="pe-7s-global" />
          <div className="dropdown">
            <p className="droptext">English(US)</p>
            <div className="dropdown-content">
              <a href="#">languague 1</a>
              <a href="#">languague 2</a>
              <a href="#">languague 3</a>
            </div>
          </div>
        </NavLink>
      </li> */}

      {/* <li className="dropdown">
        <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button"
          aria-expanded="false">English(US) <span className="caret"></span></a>
        <ul className="dropdown-menu" role="menu">
          <li><a href="#">Action</a></li>
          <li><a href="#">Another action</a></li>
          <li><a href="#">Something else here</a></li>
          <li className="divider"></li>
          <li><a href="#">Separated link</a></li>
          <li className="divider"></li>
          <li><a href="#">One more separated link</a></li>
        </ul>
      </li>
      <li className="HOVER">
        <a href="#" data-hover="More option" tabindex="-1">More options</a>
      </li> */}
    </div>
  );
};

const NavigationSuperAdmin = props => {
  return (
    <div className="nav">
      <li>
        <NavLink to="/tutorial" className="nav-link">
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={StarterGuideWhite} alt="StarterGuideWhite" />
            <div>
              <p className="navItemStyle">{props.authUser.isTutorialCompleted ? localizationStrings.overview : localizationStrings.tutorial}</p>
            </div>
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/dashboard"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-global" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={DashboardWhite} alt="DashboardWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.dashboard}</p>
            </div>
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink to="/logs" className="nav-link" onClick={() => props.checkNotif()}>
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={NotificationsWhite} alt="NotificationsWhite" />
            <p className="navItemStyle">{localizationStrings.logs}</p>
            <div className="navItemStyle">
              {props.notifStatus === true ? <img style={{height: "10px", width: "10px", margin: "auto"}} src={notificationStatus} alt="notificationStatus" /> : ""}
            </div>
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/locklist"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-note2" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={LockListWhite} alt="LockListWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.locklist}</p>
            </div>
          </div>
        </NavLink>
      </li>
      {/* <li>
        <NavLink to="/memberManagement" className="nav-link">
          <div>
            <p className="navItemStyle">
              {localizationStrings.memberManagement}
            </p>
          </div>
        </NavLink>
      </li> */}

      {/* <li>
        <NavLink
          to="/recipientManagement"
          className="nav-link"
          // style={navLinkStyle}
        > */}
      {/* <i className="pe-7s-user" style={iconStyle} /> */}
      {/* <div>
            <p className="navItemStyle">
              {localizationStrings.recipientManagement}
            </p>
          </div>
        </NavLink>
      </li> */}

      <li>
        <NavLink to="/userManagement" className="nav-link" onClick={() => props.checkNotif()}>
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={UserManagementWhite} alt="UserManagementWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.userManagement}</p>
            </div>
          </div>
        </NavLink>
      </li>

      <li>
        <NavLink
          to="/grantAccess"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-unlock" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={GranttAccessWhite} alt="GranttAccessWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.grantAccess}</p>
            </div>
          </div>
        </NavLink>
      </li>

      {/* <li>
        <NavLink to="/groupManagement" className="nav-link">
          <div>
            <p className="navItemStyle">
              {localizationStrings.groupManagement}
            </p>
          </div>
        </NavLink>
      </li> */}

      {/* <li>
        <NavLink to="/groupSharing" className="nav-link" style={navLinkStyle}>
          <i className="pe-7s-unlock" style={iconStyle} />
          <div>
            <p>Group Grant Access</p>
            <p>ハードウェア共有</p>
          </div>
        </NavLink>
      </li>  */}

      <li>
        <NavLink to="/multiApprove" className="nav-link" onClick={() => props.checkNotif()}>
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={MultiapprovalWhite} alt="MultiapprovalWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.multiApprove}</p>
            </div>
          </div>
        </NavLink>
      </li>

      <li>
        <NavLink
          to="/retractableAccess"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-shuffle" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={RetractAccessWhite} alt="RetractAccessWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.retractAccess}</p>
            </div>
          </div>
        </NavLink>
      </li>
      {/* <li>
        <NavLink
          to="/shareHistory"
          className="nav-link"
        >
      <div>
            <p className="navItemStyle">{localizationStrings.shareHistory}</p>
          </div>
        </NavLink>
      </li> */}
       {/* <li>
        <NavLink
          to="/Tracking"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        > */}
          {/* <i className="pe-7s-map-2" style={iconStyle} /> */}
          {/* <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={AccessTrackingWhite} alt="AccessTrackingWhite" style={{ width: "16px", height: "16px", margin: "auto 2px" }} />
            <div>
              <p className="navItemStyle">{localizationStrings.Access_Tracking}</p>
            </div>
          </div>
        </NavLink>
      </li> */}
      <li>
        <NavLink
          to="/audittrail"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-map-2" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={AuditTrailWhite} alt="AuditTrailWhite" />
            <div>
              <p className="navItemStyle">{localizationStrings.auditTrail}</p>
            </div>
          </div>
        </NavLink>
      </li>
      {/* <li>
        <NavLink
          to="/audittrailmapview"
          className="nav-link"
          style={navLinkStyle}
        >
          <i className="pe-7s-map" style={iconStyle} />
          <div>
            <p>{localizationStrings.auditTrailMapview}</p>
          </div>
        </NavLink>
      </li> */}

      <li>
        <NavLink
          to="/accountManagement"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-id" style={iconStyle} /> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={AccountManagementWhite} alt="AccountManagementWhite" />
            <div>
              <p className="navItemStyle">
                {localizationStrings.accountManagement}
              </p>
            </div>
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/plans"
          className="nav-link"
          onClick={() => props.checkNotif()}
          // style={navLinkStyle}
        >
          {/* <i className="pe-7s-photo-gallery" style={iconStyle}></i> */}
          <div style={{display: "flex", verticalAlign: "middle"}}>
            <img className="navIconStyle" src={PlanSubscriptionWhite} alt="PlanSubscriptionWhite" />
            <p className="navItemStyle">
              {localizationStrings.plansSubscription}
            </p>
          </div>
        </NavLink>
      </li>
      {/* <li>
        <NavLink to="/contactUs" className="nav-link">
          <div>
            <p className="navItemStyle">{localizationStrings.contactUs}</p>
          </div>
        </NavLink>
      </li> */}

      {/* Settings and Logs */}
      {/* <li>
        <NavLink to="/setting" className="nav-link" onClick={() => props.checkNotif()}>
          <div>
            <p className="navItemStyle">{localizationStrings.setting}</p>
          </div>
        </NavLink>
      </li> */}

      {/* <li>
        <NavLink to="/Test" className="nav-link">
          <p>Test</p>
        </NavLink>
      </li> */}

      {/* <li>
        <NavLink to="/#" className="nav-link">
          <i className="pe-7s-global" />
          <div className="dropdown">
            <p className="droptext">English(US)</p>
            <div className="dropdown-content">
              <a href="#">languague 1</a>
              <a href="#">languague 2</a>
              <a href="#">languague 3</a>
            </div>
          </div>
        </NavLink>
      </li> */}

      {/* <li>
        <NavLink to="/groupManagement" className="nav-link">
          <div>
            <p className="navItemStyle">Group Management</p>
          </div>
        </NavLink>
      </li> */}
    </div>
  );
};

// const TestContext = () => {
//   return (
//     <AuthUserContext.Consumer>
//       {(authUser) => {
//         if (authUser) {
//           fire
//             .database()
//             .ref("userSettings")
//             .child(authUser.uid) // get uid from auth person object
//             .child("language")
//             .once("value")
//             .then((snapshot) => {
//               // this.setState({
//               //   currentLanguage: snapshot.val(),
//               // })
//               console.log(snapshot.val())
//               // localizationStrings.setLanguage(snapshot.val())
//             })
//         }
//       }}
//     </AuthUserContext.Consumer>
//   )
// }

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      // authUser: null,
      currentLanguage: localizationStrings.getLanguage(),
      currentUserUID: "",
      uid: "",
      notifStatus: false,
    };

    this.checkNotification = this.checkNotification.bind(this);
  }

  componentWillMount() {
    this._isMounted = true;
    // customLog(auth.currentUser); //User not logon
    // console.log(auth.currentUser.uid)
    // console.log(auth.currentUser)
    this._authUnsub = auth.onAuthStateChanged(user => {
      if (user) {
        // User is signed in.
        this.setState({
          currentUserUID: user.uid
        });

        fire
          .database()
          .ref("userSettings")
          .child(user.uid)
          .child("language")
          .on("value", this._langCb = snapshot => {
            customLog(snapshot.val());
            this.setState({
              currentLanguage: snapshot.val()
            });
          });

        // check if there is unread notifications
        fire
          .database()
          .ref("individualNotifications")
          .child(user.uid)
          .once("value")
          .then(snapshot => {
            if (!this._isMounted) return;
            if (snapshot.exists()) {
              snapshot.forEach(Log => {
                let Logval = Log.val();

                if (!Logval.isRead) {
                  this.setState({
                    notifStatus: true,
                  });
                }
              });
            }
          });
      } else {
        // No user is signed in.
        customLog("Not Signed In");
      }
    });
  }

  checkNotification() {
    // check if there is unread notifications
      fire
        .database()
        .ref("individualNotifications")
        .child(auth.currentUser.uid)
        .once("value")
        .then(snapshot => {
          if (snapshot.exists()) {
            let unreadCounter;
            
            snapshot.forEach(Log => {
              let Logval = Log.val();

              if(Logval.isRead === false) {
                unreadCounter = 1;
                this.setState({
                  notifStatus: true,
                });
              }
              if (unreadCounter != 1) {
                this.setState({
                  notifStatus: false,
                });
              }
            })
          }
        });
  }

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    // console.log(this.props.authUser)
    // console.log(auth.currentUser)
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this._authUnsub) this._authUnsub();
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }
    
    return (
      <div id="sidebar" className="sidebar" data-color="black" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
         <div className="logo">
          <a href="/" className="simple-text logo-mini">
            <div className="logo-img">
              <img src={logo} alt="logo_image" />
            </div>
          </a>
          <a 
            href="/"
            className="simple-text logo-normal"
            style={{ textTransform: "none", fontSize: "30px" }}
          >
            eGeeTouch
          </a>
          <div style={{ textAlign: "right", fontSize: "16px" }}>
            Pro Version 6.17.18
          </div>
        </div>
      <div className="sidebar-wrapper" style={{ position: "relative", flex: "1 0 auto", display: "flex", flexDirection: "column" }}>
        <div className="toFixFooter" style={{ flex: "1", display: "flex", flexDirection: "column", marginBottom: "-30px" }}>
          <ul className="nav">
            {this.state.width <= 991 ? <HeaderLinks /> : null}
            {this.state.uid === "" ? <Navigation notifStatus={this.state.notifStatus} checkNotif={this.checkNotification} /> : ""}
          </ul>
          <div
            style={{ height: "69px", textAlign: "center", lineHeight: "69px", marginTop: "auto" }}
          >
            &copy; {new Date().getFullYear()}{" "}
            <a href="https://www.digipas.com" target="_blank">Digipas Technologies Inc.</a>
          </div>
        </div>
      </div>
      </div>
    );
  }
}

export default Sidebar;